<script setup lang="ts">
  import { computed } from 'vue';
  import type { TrainingDetail } from '@/entities/Training';
  import { formatRevisionNumber } from '../../lib/formatRevisionNumber';
  import TrainingDocumentsTable from '../TrainingDocumentsTable.vue';

  const props = defineProps<{
    documents: TrainingDetail['documents'];
  }>();

  const documentRows = computed(() =>
    props.documents.map((document) => ({
      id: document.documentRevisionId,
      code: document.prefix,
      name: document.title,
      revision: `Rev. ${formatRevisionNumber(document.revision)}`,
    }))
  );
</script>

<template>
  <section
    data-testid="training-control-section-documents"
    class="flex flex-col gap-4 border-b border-gray-02 px-6 py-8"
  >
    <h2 class="text-sm font-semibold text-gray-07">
      Documento SGQ
    </h2>
    <TrainingDocumentsTable
      :documents="documentRows"
      :show-view-action="false"
      :show-revision="true"
      empty-message=""
    />
  </section>
</template>
